export default __webpack_public_path__ + "static/media/skype.05e2a827.svg";